module.exports = __webpack_public_path__ + "img/itel.eafb0330.png";